import styled from 'styled-components';
import {
	WHITE_COLOR,
	NORMAL_GREY_COLOR,
	LINK_COLOR,
	URL_COLOR
} from '../config/colors';

export const Cotainer = styled.div`
	height: calc(100vh - 40px);
	display: flex;
	@media (max-width: 1200px) {
		flex-direction: column;
	}
`;

export const InfoSection = styled.div`
	flex: 2;
	height: 100%;
	// background-color: ${NORMAL_GREY_COLOR};
	padding: 0px 3rem;
    display: flex;
    align-items: center;
	justify-content: center;
	.ant-btn-primary {
        background-color: #3A4FFF !important;
        color: #fff !important;
    }
	> div {
		// width: 336px;
		// margin: auto;
		// margin-top: 3rem;
		// position: relative;
	}
	.project-wrapper {
		display: flex;
		.circle {
			height: 10px;
			width: 10px;
			background-color: #0000FF;
			border-radius: 50%;
			padding-top: 10px;
   			margin: 4px 12px 0px 0px;
		}
	}
	.info-title-wrapper {
		display: flex;
		.title-label {
			font-size: 22px;
			font-weight: bold;
			margin-bottom: 0px;
		}
		.title-icon {
			margin-right: 0.5rem;
			width: 1.5rem;
		}
	}
	.info-logo {
		height: 65px;
		margin-bottom: 10px;
		position: relative;
	}
	.wallet-label {
		display: block;
		position: absolute;
		left: 190px;
		top: 0;
		width: auto;
		padding: 0px 5px;
		background-color: #00f;
		color: #fff;
		font-size: 10px;
		border-radius: 5px;
		&.lite {
			background-color: #00f;
			color: #fff;
		}
		&.business {
			background-color: #000;
			color: #fff;
		}
		&.enterprise {
			background-color: #fff;
			color: #000;
		}
	}
	h3 {
		font-size: 22px;
		font-weight: bold;
	}
	.ant-btn {
		img {
			height: 15px;
			vertical-align: middle;
			margin-right: 8px;
		}
	}
	.ant-select {
		display: none;
	}
	.ant-btn-primary {
		font-family: NHaasGroteskTXPro, system-ui;
		display: block;
		width: 180px;
		text-align: left;
		background-color: ${WHITE_COLOR};
		color: ${LINK_COLOR};
		font-size: 12px;
		font-weight: 400 !important;
		border-color: ${LINK_COLOR};
		margin: 5px 0;
	}

	.ant-btn-danger {
		font-family: NHaasGroteskTXPro, system-ui;
		display: block;
		width: 180px;
		text-align: left;
		font-size: 12px;
		font-weight: 400 !important;
		margin: 5px 0;
	}
	a {
		text-decoration: none;
	}
	.url {
		font-size: 14px;
		color: ${URL_COLOR};
	}
	.btn-restore {
		width: 200px;
		padding: 8px 15px;
		height: auto;
		font-size: 16px;
		background: transparent;
		&:hover,
		&:active,
		&:focus {
			background: ${WHITE_COLOR};
			color: ${LINK_COLOR};
		}
	}
	.clock-icon {
		font-size: 14px;
	}
	
	.flex-center {
		display: flex;
		align-items: center;
	}
	.user-xht {
		height: 3.5rem;
		width: 3.5rem;
    	margin-right: 8px;
	}
	.title {
		font-weight: bold;
	}
	.configure-link {
		cursor: pointer;
		color: #5985ff;
		text-decoration: underline;
	}
	.public {
		color: #36E900;
	}
	.divider-line {
		border: 1px solid #808080;
		width: 30%;
		margin: 3rem 0;
	}
	.public-info {
		margin-bottom: 10px;
	}
	@media (max-width: 1670px) {
		&.exchange {
			padding-left: 45px;
		}
	}
	@media (max-width: 1200px) {
		flex: none;
		width: 100%;
		height: auto;
		/* left: -100%;
		top: 79px;
		bottom: 0;
		z-index: 12;
		transition: left; */
		.ant-btn {
			display: none;
		}
		.ant-select {
			display: block;
			width: 100%;
			margin-bottom: 12px;
			img {
				height: 15px;
				vertical-align: middle;
				margin-right: 8px;
			}
		}
		.wallet-label {
			display: none;
		}
		> div {
			width: 90%;
			margin: auto;
			margin-top: 1rem;
		}
		&.on {
			left: 0;
		}
		.info-logo {
			display: none;
		}
		&.exchange {
			padding-left: 0;
		}
	}	
	.btn-hover {
		color: #ffffff;
		&:hover,
		&:active,
		&:focus
		color: #ffffff;
		background-color: #3A4FFF;
		border-color: #3A4FFF;
		.circle {
			background-color: #ffffff;
		}
	}
`;

export const MainSection = styled.div`
	position: relative;
	flex: 5;
	overflow: auto;
	height: 100%;
	.mobile-btn {
		display: none;
	}
	.ant-spin {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}
	@media (max-width: 1200px) {
		flex: none;
		.mobile-btn {
			display: block;
			position: fixed;
			bottom: 24px;
			right: 24px;
			width: 32px;
			height: 32px;
			background-color: ${LINK_COLOR};
			color: ${WHITE_COLOR};
			line-height: 32px;
			font-size: 18px;
			text-align: center;
			font-weight: bold;
			border-radius: 16px;
			cursor: pointer;
			box-shadow: 1px 1px 2px rgba(50, 50, 50, 0.3);
			z-index: 20;
		}
	}
`;
